<div class="page-container">
  @if (client$ | async; as clientResult) {
    <app-toolbar [title]="('COMMON.ADMIN' | translate) + (clientResult.data ? ' — ' + clientResult.data.name : '')"></app-toolbar>

    <div class="page">
      <div class="client-dashboard">
        @if (clientResult.isSuccess) {
          @if (currentUser$ | async; as user) {
            <app-analytics-dashboard
              [teamIds$]="teamIds$"
              [clientIds$]="clientIds$"
              [dashboardUrl]="user.team.client.dashboardUrl"
              [subscriptionUsage$]="subscriptionUsage$"
              [showAudioMetrics]="true"
            ></app-analytics-dashboard>
          }
        } @else if (clientResult.isLoading) {
          <app-spinner></app-spinner>
        } @else if (clientResult.isError) {
          <h2 class="failed-to-load">{{ 'COMMON.FAILED_TO_LOAD' | translate }}</h2>
        }
      </div>
    </div>
  }
</div>
